// These values are also used for redux-responsive, see app/reducers.js
const breakpoints = {
  'screen-xs': '480px',
  'screen-sm': '768px',
  'screen-md': '992px'
}

const breakpointsJs = () => {
  const bjs = {}

  Object.keys(breakpoints).forEach((key) => {
    let newKey = key.split('-')
    newKey = newKey[0] + newKey[1].toUpperCase()

    bjs[newKey] = parseInt(breakpoints[key], 10)
  })

  return bjs
}

exports.breakpointsCss = breakpoints
exports.breakpointsJs = breakpointsJs()
